import ApiJobCategory from 'types/api/JobCategory';
import { Option } from 'types/options';

import Model from 'models/Model';

export default class JobCategory implements Model {
    id: string;
    name: string;
    slug: string;

    constructor(data: ApiJobCategory) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
    }

    getOption = (): Option<JobCategory> => {
        return {
            value: this,
            label: this.name,
        };
    };
}